import {
    MEDIA_TYPE_RESET,
    MEDIA_TYPES_RESET,
    MEDIA_TYPE_FOCUS,
    MEDIA_TYPE_DOWNLOADED,
    MEDIA_TYPES_DOWNLOADED,
    MEDIA_TYPES_PENDING,
    MEDIA_TYPES_FAILED,
    MEDIA_TYPE_FAILED,
    MEDIA_TYPE_POSTING,
    MEDIA_TYPE_EDITING,
    MEDIA_TYPE_DELETED,
    MEDIA_TYPE_DELETING,
    MEDIA_TYPE_PICTURE_UPLOADING,
    MEDIA_TYPE_PICTURE_UPLOADED,
    MEDIA_TYPE_PICTURE_FAILED,
    MEDIA_TYPE_PICTURE_DELETING
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: null,
    currentType: null,
    pending: false,
    sending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case MEDIA_TYPE_RESET:
            return {
                ...state,
                error: null,
                currentIndex: 0,
                sending: false,
                currentType: null
            };
        case MEDIA_TYPE_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            newState.content = state.content.filter((type)  => {
                return type.id !== action.payload
            });

            if (state.currentType) {
                if (state.currentType.id === action.payload) {
                    newState.currentType = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((type) => {
                        return newState.currentType.id === type.id
                    });
                }
            }

            return newState;
        case MEDIA_TYPES_RESET:
            return INITIAL_STATE;
        case MEDIA_TYPES_PENDING:
            return {
                ...state,
                pending: true
            };
        case MEDIA_TYPE_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(type => {
                    return type.id === action.payload.id
                }),
                currentType: action.payload
            };
        case MEDIA_TYPE_DOWNLOADED:
            let newContent = [];
            let newIndex;
            let id = action.payload.id;
            let type = state.content.find(function (type) {
                return type.id === id
            });

            if (type) {
                let index = state.content.findIndex(stateApp => {
                    return stateApp.id === type.id
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload
                ];
                newIndex = newContent.length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentType: action.payload,
                currentIndex: newIndex
            };
        case MEDIA_TYPES_DOWNLOADED:
            let newAppDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentType) {
                let newCurrentType = state.content.find(function (type) {
                    return type.id === state.currentType.id
                });
                if (newCurrentType) {
                    newAppDownloadedState.currentType = newCurrentType;
                    newAppDownloadedState.currentIndex = newAppDownloadedState.content.findIndex((type) => {
                        return newCurrentType.id === type.id
                    });
                }
            } else {
                newAppDownloadedState.currentType = null;
                newAppDownloadedState.currentIndex = null;
            }

            return newAppDownloadedState;
        case MEDIA_TYPES_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case MEDIA_TYPE_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentType: null,
                currentIndex: 0
            };
        case MEDIA_TYPE_POSTING:
            return {
                ...state,
                sending: true
            };
        case MEDIA_TYPE_EDITING:
            return {
                ...state,
                sending: true
            };
        case MEDIA_TYPE_DELETING:
            return {
                ...state,
                sending: true
            };

        case MEDIA_TYPE_PICTURE_UPLOADING:
            return {
                ...state,
                sending: true
            };
        case MEDIA_TYPE_PICTURE_UPLOADED:
            return {
                ...state,
                sending: false
            };
        case MEDIA_TYPE_PICTURE_FAILED:
            return {
                ...state,
                sending: false,
                error: action.payload
            };
        case MEDIA_TYPE_PICTURE_DELETING:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/mediatypes/reducers.js